import { Record } from "immutable";

import { TicketApprovalRequestModel } from "./TicketApprovalRequestModel";
import { TicketModel } from "./TicketModel";

export type TTicketApprovalResponseType = "adminApprove" | "adminDecline" | "approve" | "decline";

const defaults = {
  channelId: null as null | string,
  createdAt: new Date(0),
  id: "",
  request: null as null | TicketApprovalRequestModel,
  ticket: null as null | TicketModel,
  type: "" as TTicketApprovalResponseType,
  userId: null as null | string,
  webhookId: null as null | string,
};

export class TicketApprovalResponseModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown): TicketApprovalResponseModel {
    const { channelId, createdAt, id, request, ticket, type, userId, webhookId } = data as typeof defaults;
    return new TicketApprovalResponseModel({
      channelId,
      createdAt: new Date(createdAt),
      id,
      request: request ? TicketApprovalRequestModel.fromServerData(request) : null,
      ticket: ticket ? TicketModel.fromServerData(ticket) : null,
      type,
      userId,
      webhookId,
    });
  }
}
